import React from 'react'
import Business from 'containers/Business'

export default function BusinessPage() {
  return <Business />
}
